<template>
  <div
    v-if="data"
    id="func-detalhes"
    class="func-detalhe"
  >
    <el-row
      style="padding: 30px 0;"
    >
      <el-col :span="14">
        <div class="border"></div>
        <StatusCard
          :disabled="true"
          :cor="data.situacao.cor"
          style="width: 100%; margin-bottom: 15px;"
        >
          <div class="func-status-card">
            <div class="func-status-card-titulo">
              <h4>{{ data.descricaoTipoServico }}</h4>
            </div>
            <div class="func-status-card-content">
              <div class="form-status-card-info">
                <div class="func-status-card-label">
                  <small>Situação</small>
                </div>
                <div
                  class="func-status-card-valor"
                  style="font-weight: 600"
                >
                  <span :style="'color:' +  data.situacao.cor">{{ data.situacao.descricao }}</span>
                </div>
              </div>
              <div class="form-status-card-info">
                <div class="func-status-card-label">
                  Data solic.
                </div>
                <div class="func-status-card-valor">
                  {{ dataFormat(data.dataSolicitacao) }}
                </div>
              </div>
            </div>
            <div class="func-status-card-content">
            <div style="margin-top: 10px; flex: 1">
              <div class="func-status-card-label">
                Valor Solic.
              </div>
              <div class="func-status-card-valor">
                {{ valorFormat(parseFloat(data.valorTotalSolicitado)) }}
              </div>
            </div>
              <div v-show="data.valorTotalReembolsado != 0" style="margin-top: 10px; flex: 1">
                <div class="func-status-card-label">
                  Valor liberado
                </div>
                <div class="func-status-card-valor">
                  {{ valorFormat(parseFloat(data.valorTotalReembolsado)) }}
                </div>
              </div>
            </div>
            <div class="func-status-card-content">
              <div style="margin-top: 10px; flex: 1">
                <div class="func-status-card-label">
                  Data Prev. Pagamento.
                </div>
                <div class="func-status-card-valor">
                  {{ dataFormat(data.dataPrevisaoPagamento) }}
                </div>
              </div>
              <div style="margin-top: 10px; flex: 1">
                <div class="func-status-card-label">
                  Valor Total Glosado
                </div>
                <div class="func-status-card-valor">
                  {{ valorFormat(parseFloat(data.valorTotalGlosado)) }}
                </div>
              </div>
            </div>
          </div>
        </StatusCard>
        <el-card
          class="protocolo-card"
          style="width: 100%;"
        >
          <div class="func-status-card card-beneficiario">
            <div class="func-status-card-beneficiario">
              <div style="display: flex">
              <div
                style="flex: 1;"
              >
                <div class="func-status-card-label">
                  BENEFICIÁRIO:
                </div>
                <div
                  class="func-status-card-valor"
                  style="font-weight: 600;"
                >
                  {{ data.nomeBeneficiario }}
                </div>
                <div>
                  <small>{{ beneficiario.matricula}}</small>
                  <span style="margin-left: 10px; font-size: 12px">{{tipoBeneficiario}}</span>
                </div>
              </div>
              <div style="flex: 0.1">
                <div
                  :style="beneficiarioIconeStyle"
                  class="circle"
                >
                  <div class="abreviatura">
                    {{ beneficiario.abreviacao }}
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </el-card>
        <div style="width: 100%; padding-bottom: 10px">
          <span style="font-size: 14px;  padding: 5px; margin-bottom: 5px; display: block;"><b>{{ funcionalidade.parametros.textos.tituloDespesas }}</b></span>
          <cardDropdown
            v-for="(despesa, i) in data.despesas"
            :key="i"
            :entradaId="i + 1"
            :aberto="aberto"
            :tipo-despesa="true"
            :despesa="despesa">
          </cardDropdown>
        </div>
        <div v-for="(complemento, i) in data.complementos" :key="i" style="width: 100%">
          <span style="font-size: 14px;  padding: 5px; margin-bottom: 5px; display: block;"><b>{{funcionalidade.parametros.textos.tituloDadosBancarios}}</b></span>
          <cardDropdown
            :aberto="true"
            :tipo-despesa="false"
            :despesa="complemento.campos">
          </cardDropdown>
        </div>
        <div>
        </div>
      </el-col>
      <el-col :span="10">
        <el-card class="protocolo-card">
          <div class="field">
            <small class="protocolo-title">PROTOCOLO</small>
            <span class="text-blue-max">{{data.numeroProtocolo}}</span>
            <el-button style="float: right" @click="copiar" class="btn-icon"><inline-svg :src="require('@/assets/icons/icon_btn_copy.svg')"></inline-svg></el-button>
          </div>
          <div class="field">
            <small class="protocolo-title">Nº DA GUIA</small>
            <span class="text-blue-max">{{data.numeroGuiaReembolso}}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import StatusCard from '@/components/cards/StatusCard'
import CardDropdown from '@/components/cards/CardDropdown'
import { mapGetters, mapState } from 'vuex'
import InlineSvg from 'vue-inline-svg'
import moment from 'moment'
import { formatAbreviatura, formatBeneficiarios, getCorAleatoria } from '@/components/GrupoFamiliar/GrupoFamiliarHelpers'
export default {
  data () {
    return {
      data: {},
      showDiv: false
    }
  },
  components: { StatusCard, CardDropdown, InlineSvg },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapGetters('Login', ['user', 'contratos', 'beneficiarios', 'hasMultPerfil']),
    aberto () {
      return this.data.despesas.length <= 1
    },
    beneficiario () {
      if (this.data) {
        if (this.hasMultPerfil && this.beneficiarios.length === 0) {
          return {
            nome: this.user.nome,
            cor: getCorAleatoria(),
            abreviacao: formatAbreviatura(this.user.nome),
            chaveUnica: this.user.chaveUnica
          }
        }
        if (this.data.nomeBeneficiario && this.data.numeroContrato) {
          const beneficiarios = formatBeneficiarios(
            [{ chaveUnica: this.data.chaveUnica }],
            this.beneficiarios,
            { numeroContrato: this.data.numeroContrato }
          )
          return beneficiarios[0] || {}
        }
      }
      return {}
    },
    beneficiarioIconeStyle () {
      return {
        background: this.beneficiario.cor
      }
    },
    tipoBeneficiario () {
      let beneficiarioTipo = this.data.idTipoBeneficiario
      let value = ''
      if (beneficiarioTipo === 'T') {
        value = 'Titular'
      }
      if (beneficiarioTipo === 'B') {
        value = 'Beneficiário'
      }
      return value
    }
  },
  methods: {
    async init () {
      const res = await this.apiFuncionalidade.detalhe({
        payload: {
          idReembolso: this.$route.query.idOcorrencia,
          numeroGuiaReembolso: this.$route.query.idGuia
        }
      })
      this.data = res.data
    },
    valorFormat (valor) {
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    dataFormat (valor) {
      if (!valor) {
        return '-'
      }
      return moment(valor).format('DD/MM/YYYY')
    },
    copiar () {
      this.$clipboard(this.data.numeroProtocolo)
    }
  },
  created () {
    this.init()
  }
}
</script>
<style lang="less" scoped>
#func-10-detalhe {
  padding: 15px 20px;
  .func-status-card {
    width: 100%;
    padding: 1px;
  }

  .card-beneficiario {
    padding: 5px;
  }

  .func-status-card-titulo {
    font: normal normal 600 18px/24px Open Sans;
    letter-spacing: 0;
    color: #333333;
  }

  .func-detalhe {
    padding: 0 20px;

    .func-status-card-content {
      display: flex;
      flex-flow: row wrap;

      .form-status-card-info {
        width: 50%;
        margin-top: 10px;
        flex: 1;
      }
    }
  }
  .func-status-card-label {
    font: normal normal normal 11px/15px Open Sans;
    letter-spacing: 0;
    color: #555555;
    word-spacing: 5px;
  }
  .button-cancelar {
    box-shadow: none;
    border: none;
    border-radius: 6px;
    background: #EBF4FA;
  }
  .protocolo-card {
    box-shadow: none;
    border: none;
    border-radius: 6px;
    background: #F6F6F6 0 0 no-repeat padding-box;

    .protocolo-title {
      display: block;
      line-height: 24px;
      color: #555555;
    }
    .text-blue-max {
      color: #006FB9;
      font-weight: 600;
      font-size: 18px;
    }
    .field:first-child {
      margin-bottom: 15px;
    }
  }
  .text-blue-mid {
    color: #006FB9;
    font-weight: 600;
    font-size: 15px;
  }
  .el-col-14 {
    padding-right: 40px;
  }
  .btn {
    width: 100%;
    padding: 20px 15px;
    text-align: left !important;
    margin-bottom: 5px;
  }
  .btn-icon{
    border:none;
    float: right;
  }
  .border {
    border-right: solid 1px #EEEEEE;
    display: block;
    height: 100%;
    position: absolute;
    left: 56.4%;
    top: 1px;
  }
  .abreviatura {
    font-size: 17px;
    color: #FFFFFF;
  }

  .circle {
    height: 35px;
    width: 35px;
    border-radius: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .func-status-card-valor {
    font: normal normal normal 14px/19px Open Sans;
    letter-spacing: 0;
    color: #333333;
    font-weight: 600;
  }

}
</style>
